export default {
  name: 'PageFooter',
  props: ['copyright', 'linkList']
};